import { createRouter, createWebHistory } from 'vue-router'
import OnCheck from '../views/OnCheck.vue'
import OnDuty from '../views/OnDuty.vue'
import ClientView from '../views/ClientView.vue'
import BindWxUserKey from '../views/BindWxUserKey.vue'

const routes = [
  {
    path: '/',
    name: 'OnCheck',
    component: OnCheck,
    meta: { title: '司机微信验证' },
  },
  {
    path: '/1',
    name: 'OnDuty',
    component: OnDuty,
    meta: { title: '电子值勤单' },
  },
  {
    path: '/2',
    name: 'BindWxUserKey',
    component: BindWxUserKey,
    meta: { title: '钥匙卡绑定微信号' },
  },
  {
    path: '/client',
    name: 'ClientView',
    component: ClientView,
    meta: { title: '电子值勤单查询WEB应用' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  document.title = to.meta.title || '';
  // 仅当在微信浏览器打开时执行
  const isWechatBrowser = /MicroMessenger/i.test(navigator.userAgent);
  if (isWechatBrowser) {
    history.pushState(null, null, '/#');
    window.addEventListener('popstate', function () {
      history.pushState(null, null, '/#');
    });
  }
});

export default router
